module.exports = __webpack_public_path__ + "img/shareInfo1.6f3f7679.png";